"use client";

import { c as _c } from "react/compiler-runtime";
import { useLocale } from "@repo/design-system/hooks/use-locale";
import { useRegistry } from "~/components/registry/registry-provider";
import { template } from "~/translations/loader/template";
import { useLanguage } from "~/translations/loader/use-language";

/**
 * Privacy notice pointing to the recruiting privacy policy page of this app.
 * Resolution order: explicit `href` prop → `ui.privacyPolicyHref` from the
 * client registry (e.g. the E.ON UK policy for uk/controlsolutions/eco2solar)
 * → this app's `/privacy-policy-recruiting` page.
 */
export default function PrivacyNotice(t0) {
  const $ = _c(11);
  const {
    className,
    href
  } = t0;
  const t = useLanguage();
  const locale = useLocale();
  const {
    ui
  } = useRegistry();
  const resolvedHref = href ?? ui.privacyPolicyHref ?? `/${locale}/privacy-policy-recruiting`;
  const link = `<a class="underline" href="${resolvedHref}" rel="noopener" target="_blank">${t.jobad_privacy_linkText}</a>`;
  let t1;
  if ($[0] !== t.jobad_privacy_HL) {
    t1 = <p className="font-bold" data-source="lc">{t.jobad_privacy_HL}</p>;
    $[0] = t.jobad_privacy_HL;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== link || $[3] !== t.jobad_privacy_text) {
    t2 = template(t.jobad_privacy_text, {
      link
    });
    $[2] = link;
    $[3] = t.jobad_privacy_text;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <p dangerouslySetInnerHTML={{
      __html: t2
    }} data-source="lc" />;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== className || $[8] !== t1 || $[9] !== t3) {
    t4 = <div className={className}>{t1}{t3}</div>;
    $[7] = className;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}